import FormJaivana from 'dashboard_jaivana_v1';
/**
 *
 * @author Anderson Acevedo
 * 
 * @version jdesk_1.01.0002
 */
/**
 * Custom con funciones adicionales al Formulario
 **/
class CustomMedidasDeLosArticulos extends FormJaivana.form {

    constructor(props) {

        super(props);
        this.initForm = this.initForm.bind(this);

        this.traerMedidas = this.traerMedidas.bind(this);

        this.limpiarCampos = this.limpiarCampos.bind(this);

        this.mostrarMensajeNoHayDatos = this.mostrarMensajeNoHayDatos.bind(this);
        this.mostrarMensajeAdicional = this.mostrarMensajeAdicional.bind(this);
        this.mostrarMensajeGenerando = this.mostrarMensajeGenerando.bind(this);
        this.traerPropiedades = this.traerPropiedades.bind(this);
        this.sucesstraerPropiedades = this.sucesstraerPropiedades.bind(this);
        this.successMedidas = this.successMedidas.bind(this);
        this.traerAdicionales = this.traerAdicionales.bind(this);
        this.successAdicionales = this.successAdicionales.bind(this);

        this.sucessActualizar = this.sucessActualizar.bind(this);
        this.actualizarMedidas = this.actualizarMedidas.bind(this);

        //imprimir

        this.mostrarMensajeEmailFallo                         =this.mostrarMensajeEmailFallo.bind(this);
        this.mostrarMensajeEmailEnviado                         =this.mostrarMensajeEmailEnviado.bind(this);


        this.currencyFormatterGeneral = this.currencyFormatterGeneral.bind(this);
        this.formatNumberSaldo = this.formatNumberSaldo.bind(this);
        this.servicio = '';
        this.sucursal_ingreso = '';
        this.numero_decimales = 2;
        this.fila_seleccionada=[];
    }

    initForm() {
        console.log('Formulario CustomMedidasDeLosArticulos,  @version: jdesk_1.01.0003, @author:Anderson Acevedo');
        this.sucursal_ingreso = JSON.parse(localStorage.getItem('sucursal_ingreso')).codigo_sucursal;
        this.traerPropiedades();

        this.getField('nombre_articulo').setOnChange((props) => {
            if(this.getField('nombre_articulo').getValue()!=='' && this.getField('nombre_articulo').getValue()!==' '){
                this.traerMedidas();
                this.traerAdicionales();
            }else{
                this.limpiarCampos();
            }
            
        });

        this.getField('bt_actualizar').setClick(()=>{
            this.actualizarMedidas();
        });

    }


    actualizarMedidas(){
        if(this.getField('codigo_articulo').valid() && 
        this.getField('nombre_articulo').valid() &&
        this.getField('barras').valid() &&
        this.getField('peso').valid() &&
        this.getField('altura').valid() &&
        this.getField('profundidad').valid() &&
        this.getField('ancho').valid() &&
        this.getField('ubicacion').valid() &&
        this.getField('seccion').valid() &&
        this.getField('bandeja').valid() &&
        this.getField('lugar').valid() &&
        this.getField('cuantos').valid() &&
        this.getField('caras').valid() &&
        this.getField('maximo').valid() &&
        this.getField('minimo').valid()){
            this.mostrarMensajeGuardando();
            let datos={ datos: {
                sucursal_ingreso:this.sucursal_ingreso,
                codigo_articulo:this.getField('codigo_articulo').getValue(),
                nombre_articulo :this.getField('nombre_articulo').getValue(),
                barras:this.getField('barras').getValue(),
                peso:this.getField('peso').getValue(), 
                altura:this.getField('altura').getValue(),
                profundidad:this.getField('profundidad').getValue(),
                ancho :this.getField('ancho').getValue(),
                ubicacion:this.getField('ubicacion').getValue(),
                seccion:this.getField('seccion').getValue(),
                bandeja:this.getField('bandeja').getValue(),
                lugar:this.getField('lugar').getValue(),
                cuantos:this.getField('cuantos').getValue(),
                caras:this.getField('caras').getValue(),
                maximo:this.getField('maximo').getValue(),
                minimo:this.getField('minimo').getValue(),
                
            }};
            this.generalFormatPmv = { tipo_servicio: 'inve-medidasdelosarticulos', operacion: 'modificarmedidas', operacion_tipo: 'modificar' };
            this.service.send(
            {
                    endpoint: this.constant.formConfiguration(),
                    method:'PUT',
                    body: datos,
                    success: this.sucessActualizar,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
            });
        }else{
            this.mostrarMensajeAdicional('Existe un campo vacío o mal configurado.');
        }
    }

    sucessActualizar(data) {
        this.getField('confirmModalCustom').toggle(false);
        if(data.estado_p === 200){
            this.mostrarMensajeAdicional('Medidas actualizas con éxito.');
        }else {
          if(data.estado_p===404) {
            this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
          }
          else {
            let respuesta=Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
          }
        }
      }



    traerPropiedades() {
        let datos = { datos: {
            sucursal_ingreso:this.sucursal_ingreso
        } };
        this.generalFormatPmv = { tipo_servicio: 'inve-medidasdelosarticulos', operacion: 'traerpropiedades', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.sucesstraerPropiedades,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });

    }

    sucesstraerPropiedades(data) {
        this.getField('confirmModalCustom').toggle(false);
        
        if (data.estado_p === 200) {
            this.numero_decimales = data.data.numero_decimales;
        } else if (data.estado_p === 404) {
            //this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }



    limpiarCampos() {
        this.getField('nombre_articulo').setError(false,'');
        this.getField('peso').setError(false,'');
        this.getField('barras').setError(false,'');
        this.getField('altura').setError(false,'');
        this.getField('profundidad').setError(false,'');
        this.getField('ancho').setError(false,'');
        this.getField('ubicacion').setError(false,'');
        this.getField('seccion').setError(false,'');
        this.getField('bandeja').setError(false,'');
        this.getField('lugar').setError(false,'');
        this.getField('cuantos').setError(false,'');
        this.getField('caras').setError(false,'');
        this.getField('maximo').setError(false,'');
        this.getField('minimo').setError(false,'');

        this.getField('altura').setValue(0);
        this.getField('profundidad').setValue(0);
        this.getField('ancho').setValue(0);
        this.getField('cuantos').setValue(0);
        this.getField('caras').setValue(0);
    }



    traerMedidas() {
        let errores = 0;
        this.limpiarCampos();
    

        if (!this.getField('codigo_articulo').valid() && !this.getField('nombre_articulo').valid())
            errores++;

        if (errores === 0) {
            let datos = {
                datos: {
                    codigo_articulo: this.getField("codigo_articulo").getValue(),
                }
            };
            this.mostrarMensajeGenerando();
            this.generalFormatPmv = { tipo_servicio: 'inve-medidasdelosarticulos', operacion: '1_medidas', operacion_tipo: 'consulta' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: datos,
                    success: this.successMedidas,
                    error: this.error_,
                    general: this.generalFormatPmv
                });
        }
    }


    successMedidas(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            this.getField('altura').setValue(data.data[0].altura);
            this.getField('ancho').setValue(data.data[0].ancho);
            this.getField('profundidad').setValue(data.data[0].profundidad);
        } else {
           //this.mostrarMensajeNoHayDatos();
        }
    }

    traerAdicionales() {
        let errores = 0;
        this.limpiarCampos();
    

        if (!this.getField('codigo_articulo').valid() && !this.getField('nombre_articulo').valid())
            errores++;

        if (errores === 0) {
            let datos = {
                datos: {
                    codigo_articulo: this.getField("codigo_articulo").getValue(),
                }
            };
            this.mostrarMensajeGenerando();
            this.generalFormatPmv = { tipo_servicio: 'inve-medidasdelosarticulos', operacion: '1_adicionales', operacion_tipo: 'consulta' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: datos,
                    success: this.successAdicionales,
                    error: this.error_,
                    general: this.generalFormatPmv
                });
        }
    }


    successAdicionales(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            this.getField('cuantos').setValue(data.data[0].cuantos);
            this.getField('caras').setValue(data.data[0].caras);
        } else {
           //this.mostrarMensajeNoHayDatos();
        }
    }


    currencyFormatterGeneral(number) {
        let decimal = (number + "").split(".")[1];//para manejar los decimales
        if ((decimal !== 0) && (decimal !== undefined)) {
            if (decimal.length > this.numero_decimales) {
                number = number.toFixed(this.numero_decimales); //para que redondea a dos decimales
                decimal = (number + "").split(".")[1];
            }
            return (this.formatNumberSaldo(number) + "," + decimal);
        } else {
            return this.formatNumberSaldo(number);
        }
    }

    formatNumberSaldo(number) {
        return Number(number).toFixed(this.numero_decimales).toString().split('.')[0]
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    }


    mostrarMensajeGuardando(){
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está guardando la información... `);
        this.getField('confirmModalCustom').setClickDialog(()=>{});  
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setClickCancelDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeAdicional(mensaje) {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', mensaje);
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setClickCancelDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeGenerando() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está generando la información... `);
        this.getField('confirmModalCustom').setClickDialog(() => { });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);

    }

    mostrarMensajeNoHayDatos() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'La consulta no arrojo datos.');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    //mensajes correo

    mostrarMensajeEmailEnviado() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'Email enviado exitosamente...');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeEmailFallo() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', 'Error al enviar el email...');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }


}
FormJaivana.addController("inve-medidasdelosarticulos", CustomMedidasDeLosArticulos);
export default CustomMedidasDeLosArticulos